'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _Symbol = require('@babel/runtime-corejs3/core-js-stable/symbol');
var _getIteratorMethod = require('@babel/runtime-corejs3/core-js/get-iterator-method');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var _Set = require('@babel/runtime-corejs3/core-js-stable/set');
require('../error/index.js');
require('../utils/index.js');
var edge_model = require('./edge.model.js');
var edgeStyle_model = require('./edge-style.model.js');
var graphStyle_model = require('./graph-style.model.js');
var vertex_model = require('./vertex.model.js');
var vertexStyle_model = require('./vertex-style.model.js');
var graphStudioError_model = require('../error/graph-studio-error.model.js');
var constants = require('../utils/constants.js');
var formatValidator = require('../utils/format-validator.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _Symbol__default = /*#__PURE__*/_interopDefaultLegacy(_Symbol);
var _getIteratorMethod__default = /*#__PURE__*/_interopDefaultLegacy(_getIteratorMethod);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);
var _Set__default = /*#__PURE__*/_interopDefaultLegacy(_Set);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol__default["default"] && _getIteratorMethod__default["default"](r) || r["@@iterator"]; if (!t) { if (_Array$isArray__default["default"](r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context24; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty__default["default"](_context24 = {}.toString.call(r)).call(_context24, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from__default["default"](r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/**
 * GSQL Graph json representation interface following the format:
 *   {
 *     "GraphName": string,
 *     "VertexTypes": GSQLVertexJson[],
 *     "EdgeTypes": GSQLEdgeJson[]
 *   }
 *
 * @export
 * @interface GSQLGraphJson
 */

/**
 * Graph describes graph schema in TigerGraph system, including the graph's name,
 * vertex types and edge types.
 *
 * @export
 * @class Graph
 */
var Graph = /*#__PURE__*/function () {
  /**
   * Creates an instance of Graph.
   *
   * @memberof Graph
   */
  function Graph() {
    _classCallCheck__default["default"](this, Graph);
    this.name = 'MyGraph';
    this.vertexTypes = [];
    this.edgeTypes = [];
  }

  /**
   * Clone the graph.
   *
   * @returns {Graph}
   * @memberof Graph
   */
  return _createClass__default["default"](Graph, [{
    key: "clone",
    value: function clone() {
      var _context, _context2;
      var graph = new Graph();
      graph.name = this.name;
      _forEachInstanceProperty__default["default"](_context = this.vertexTypes).call(_context, function (vertexType) {
        graph.vertexTypes.push(vertexType.clone());
      });
      _forEachInstanceProperty__default["default"](_context2 = this.edgeTypes).call(_context2, function (edgeType) {
        graph.edgeTypes.push(edgeType.clone());
      });
      return graph;
    }

    /**
     * Load Graph from GSQL Graph json representation.
     *
     * @param {GSQLGraphJson} graphJson GSQL Graph json representation
     * @returns {Graph}
     * @memberof Graph
     */
  }, {
    key: "loadFromGSQLJson",
    value: function loadFromGSQLJson(graphJson) {
      var _context3,
        _context4,
        _context5,
        _this = this;
      // GraphName
      this.name = graphJson.GraphName;

      // VertexTypes
      this.vertexTypes = _mapInstanceProperty__default["default"](_context3 = graphJson.VertexTypes).call(_context3, function (v) {
        var vertex = new vertex_model.Vertex();
        vertex.loadFromGSQLJson(v);
        return vertex;
      });

      // EdgeTypes
      this.edgeTypes = _mapInstanceProperty__default["default"](_context4 = graphJson.EdgeTypes).call(_context4, function (e) {
        var edge = new edge_model.Edge();
        edge.loadFromGSQLJson(e);
        return edge;
      });

      // For the edge types with * but without edge pair list, materialize the pairs.
      _forEachInstanceProperty__default["default"](_context5 = this.edgeTypes).call(_context5, function (edgeType) {
        var _context6;
        var fromTypeList = [edgeType.fromToVertexTypePairs[0].from];
        var toTypeList = [edgeType.fromToVertexTypePairs[0].to];
        if (fromTypeList[0] !== '*' && toTypeList[0] !== '*') {
          return;
        }
        var vertexTypes = _mapInstanceProperty__default["default"](_context6 = _this.vertexTypes).call(_context6, function (vertexType) {
          return vertexType.name;
        });
        if (!edgeType.isLocal) {
          var _context7, _context8;
          vertexTypes = _mapInstanceProperty__default["default"](_context7 = _filterInstanceProperty__default["default"](_context8 = _this.vertexTypes).call(_context8, function (vt) {
            return !vt.isLocal;
          })).call(_context7, function (vertexType) {
            return vertexType.name;
          });
        }
        if (fromTypeList[0] === '*') {
          fromTypeList = vertexTypes;
        }
        if (toTypeList[0] === '*') {
          toTypeList = vertexTypes;
        }
        edgeType.fromToVertexTypePairs = [];
        var _iterator = _createForOfIteratorHelper(fromTypeList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var fromType = _step.value;
            var _iterator2 = _createForOfIteratorHelper(toTypeList),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var toType = _step2.value;
                edgeType.fromToVertexTypePairs.push({
                  from: fromType,
                  to: toType
                });
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });

      // Do semantic check
      var semanticResult = this.semanticCheck();
      if (!semanticResult.success) {
        throw new graphStudioError_model.GraphStudioError(semanticResult.message);
      }
      return this;
    }

    /**
     * Dump Graph into GSQL Graph json representation.
     *
     * @returns {GSQLGraphJson}
     * @memberof Graph
     */
  }, {
    key: "dumpToGSQLJson",
    value: function dumpToGSQLJson() {
      var _context9, _context10;
      return {
        GraphName: this.name,
        VertexTypes: _mapInstanceProperty__default["default"](_context9 = this.vertexTypes).call(_context9, function (vertex) {
          return vertex.dumpToGSQLJson();
        }),
        EdgeTypes: _mapInstanceProperty__default["default"](_context10 = this.edgeTypes).call(_context10, function (edge) {
          return edge.dumpToGSQLJson();
        })
      };
    }

    /**
     * Get one vertex given it's type name.
     *
     * @param {string} name
     * @returns {Vertex}
     * @memberof Graph
     */
  }, {
    key: "getVertex",
    value: function getVertex(name) {
      var _iterator3 = _createForOfIteratorHelper(this.vertexTypes),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var vertex = _step3.value;
          if (vertex.name === name) {
            return vertex;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    /**
     * Get one edge give it's type name. If reverse is true,
     * then check if the schema edge has a reverse edge with the given name,
     * and return the schema edge.
     *
     * @param {string} name
     * @param {boolean} reverse
     * @returns {Edge}
     * @memberof Graph
     */
  }, {
    key: "getEdge",
    value: function getEdge(name, reverse) {
      var _iterator4 = _createForOfIteratorHelper(this.edgeTypes),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var edge = _step4.value;
          if (edge.name === name || reverse && edge.hasReverseEdge && edge.reverseEdge === name) {
            return edge;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }

    /**
     * Get the graph visualization information.
     *
     * @returns {GraphVis}
     * @memberof Graph
     */
  }, {
    key: "getVis",
    value: function getVis() {
      var _context11, _context12;
      var graphVis = {
        nodes: [],
        links: []
      };

      // Add all vertex types vis
      _forEachInstanceProperty__default["default"](_context11 = this.vertexTypes).call(_context11, function (vertexType) {
        graphVis.nodes.push(vertexType.getVis());
      });

      // Add all edge types vis
      _forEachInstanceProperty__default["default"](_context12 = this.edgeTypes).call(_context12, function (edgeType) {
        var _context13;
        // update edge vis
        graphVis.links = _concatInstanceProperty__default["default"](_context13 = graphVis.links).call(_context13, edgeType.getVis());
      });
      return graphVis;
    }

    /**
     * Apply the vertex style to a vertex type.
     *
     * @param {string} typeName
     * @param {VertexStyle} vStyle
     * @memberof Graph
     */
  }, {
    key: "applyVertexStyle",
    value: function applyVertexStyle(typeName, vStyle) {
      var _context14;
      _forEachInstanceProperty__default["default"](_context14 = this.vertexTypes).call(_context14, function (vertexType) {
        if (vertexType.name === typeName) {
          vertexType.style = vStyle;
        }
      });
    }

    /**
     * Apply the edge style to an edge type.
     *
     * @param {string} typeName
     * @param {EdgeStyle} eStyle
     * @memberof Graph
     */
  }, {
    key: "applyEdgeStyle",
    value: function applyEdgeStyle(typeName, eStyle) {
      var _context15;
      _forEachInstanceProperty__default["default"](_context15 = this.edgeTypes).call(_context15, function (edgeType) {
        if (edgeType.name === typeName) {
          edgeType.style = eStyle;
        }
      });
    }

    /**
     * Apply the graph style to the graph.
     *
     * @param {GraphStyle} gStyle
     * @memberof Graph
     */
  }, {
    key: "applyGraphStyle",
    value: function applyGraphStyle(gStyle) {
      var _context16,
        _this2 = this,
        _context17;
      // Apply vertex styles
      _forEachInstanceProperty__default["default"](_context16 = gStyle.vertexStyles).call(_context16, function (vStyle, name) {
        _this2.applyVertexStyle(name, vStyle);
      });
      // Apply edge styles
      _forEachInstanceProperty__default["default"](_context17 = gStyle.edgeStyles).call(_context17, function (eStyle, name) {
        _this2.applyEdgeStyle(name, eStyle);
      });
    }

    /**
     * Get a new vertex style.
     *
     * @param {string} vertexType
     * @param {Color} color
     * @returns {VertexStyle}
     * @memberof Graph
     */
  }, {
    key: "getNewVertexStyle",
    value: function getNewVertexStyle(vertexType, color) {
      var _context18;
      var MAX_NUMBER = 10000000000;
      var vertexStyle = new vertexStyle_model.VertexStyle();
      vertexStyle.other = {};
      vertexStyle.fillColor = color.getColor(vertexType);

      // Get the medium y axis coordinate, and maximal x axis coordination.
      // The newly added vertex will be added to the right of the above position by 150px.
      var minX = MAX_NUMBER;
      var minY = MAX_NUMBER;
      var maxX = -MAX_NUMBER;
      var maxY = -MAX_NUMBER;
      _forEachInstanceProperty__default["default"](_context18 = this.vertexTypes).call(_context18, function (vertex) {
        if (vertex.style !== undefined) {
          minX = Math.min(minX, vertex.style.x);
          minY = Math.min(minY, vertex.style.y);
          maxX = Math.max(maxX, vertex.style.x);
          maxY = Math.max(maxY, vertex.style.y);
        }
      });

      // No vertex position set yet.
      if (minX > maxX) {
        vertexStyle.x = vertexStyle.y = 0;
      } else {
        vertexStyle.x = maxX + 150;
        vertexStyle.y = (minY + maxY) / 2;
      }
      return vertexStyle;
    }

    /**
     * Get a new edge style.
     *
     * @param {string} edgeType
     * @param {Color} color
     * @returns {EdgeStyle}
     * @memberof Graph
     */
  }, {
    key: "getNewEdgeStyle",
    value: function getNewEdgeStyle(edgeType, color) {
      var edgeStyle = new edgeStyle_model.EdgeStyle();
      edgeStyle.other = {};
      edgeStyle.fillColor = color.getColor(edgeType);
      return edgeStyle;
    }

    /**
     * Retrieve graph style out of graph.
     *
     * @returns {GraphStyle}
     * @memberof Graph
     */
  }, {
    key: "getGraphStyle",
    value: function getGraphStyle() {
      var _context19, _context20;
      var graphStyle = new graphStyle_model.GraphStyle();
      _forEachInstanceProperty__default["default"](_context19 = this.vertexTypes).call(_context19, function (vertexType) {
        if (vertexType.style !== undefined) {
          graphStyle.vertexStyles.set(vertexType.name, vertexType.style);
        }
      });
      _forEachInstanceProperty__default["default"](_context20 = this.edgeTypes).call(_context20, function (edgeType) {
        if (edgeType.style !== undefined) {
          graphStyle.edgeStyles.set(edgeType.name, edgeType.style);
        }
      });
      return graphStyle;
    }

    /**
     * Return all vertex type names.
     *
     * @returns {string[]}
     * @memberof Graph
     */
  }, {
    key: "getAllVertexTypes",
    value: function getAllVertexTypes() {
      var _context21;
      var vTypeNames = [];
      _forEachInstanceProperty__default["default"](_context21 = this.vertexTypes).call(_context21, function (vertexType) {
        vTypeNames.push(vertexType.name);
      });
      return vTypeNames;
    }

    /**
     * Return all edge type names.
     *
     * @returns {string[]}
     * @memberof Graph
     */
  }, {
    key: "getAllEdgeTypes",
    value: function getAllEdgeTypes() {
      var _context22;
      var eTypeNames = [];
      _forEachInstanceProperty__default["default"](_context22 = this.edgeTypes).call(_context22, function (edgeType) {
        eTypeNames.push(edgeType.name);
      });
      return eTypeNames;
    }

    /**
     * Semantic check graph to be valid graph.
     *
     * @returns {ValidateResult}
     * @memberof Graph
     */
  }, {
    key: "semanticCheck",
    value: function semanticCheck() {
      // 1. Invalid graph name.
      if (this.name !== constants.GLOBAL_GRAPH_NAME) {
        /**
         * Since graph name cannot be changed after creation,
         * we can only check name cannot be the GLOBAL_GRAPH_NAME when create graph.
         */
        var validateName = formatValidator.FormatValidator.isName(this.name);
        if (!validateName.success) {
          var _context23;
          return {
            success: false,
            message: _concatInstanceProperty__default["default"](_context23 = "Invalid graph name \"".concat(this.name, "\". ")).call(_context23, validateName.message)
          };
        }
      }

      // 2. Semantic check each vertex and edge type.
      var names = new _Map__default["default"]();
      var vertexNames = new _Set__default["default"]();
      var _iterator5 = _createForOfIteratorHelper(this.vertexTypes),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var vertex = _step5.value;
          vertexNames.add(vertex.name);
          var checkResult = vertex.semanticCheck();
          if (!checkResult.success) {
            return checkResult;
          }
          checkResult = this.checkGraphNameAndEntityNameNoConfliction(names, vertex.name);
          if (!checkResult.success) {
            return checkResult;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var _iterator6 = _createForOfIteratorHelper(this.edgeTypes),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var edge = _step6.value;
          var _checkResult = edge.semanticCheck();
          if (!_checkResult.success) {
            return _checkResult;
          }
          _checkResult = this.checkGraphNameAndEntityNameNoConfliction(names, edge.name);
          if (!_checkResult.success) {
            return _checkResult;
          }
          // Also check reverse edge type name, cannot be duplicated with other types.
          if (edge.hasReverseEdge) {
            _checkResult = this.checkGraphNameAndEntityNameNoConfliction(names, edge.reverseEdge);
            if (!_checkResult.success) {
              return _checkResult;
            }
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      var _iterator7 = _createForOfIteratorHelper(this.edgeTypes),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _edge = _step7.value;
          // 3. Edge from-vertex and to-vertex should be in schema.
          var _iterator8 = _createForOfIteratorHelper(_edge.fromToVertexTypePairs),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var pair = _step8.value;
              if (!vertexNames.has(pair.from)) {
                return {
                  success: false,
                  message: "Edge source vertex type \"".concat(pair.from, "\" is not in graph.")
                };
              }
              if (!vertexNames.has(pair.to)) {
                return {
                  success: false,
                  message: "Edge target vertex type \"".concat(pair.to, "\" is not in graph.")
                };
              }
            }
            // 4. Edge type pair list cannot be empty.
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
          if (_edge.fromToVertexTypePairs.length === 0) {
            return {
              success: false,
              message: "Edge type doesn't have any source and target vertex type."
            };
          }
        }

        // success
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return {
        success: true
      };
    }

    /**
     * Helper function to check vertex, edge names and graph name don't have conflicts.
     * - Vertices and edges shouldn't have same name with graph.
     * - Vertices and edges shouldn't have same name with each other.
     *
     * @private
     * @param {Map<string, number>} names
     * @param {string} name
     * @returns {ValidateResult}
     * @memberof Graph
     */
  }, {
    key: "checkGraphNameAndEntityNameNoConfliction",
    value: function checkGraphNameAndEntityNameNoConfliction(names, name) {
      if (name === this.name) {
        return {
          success: false,
          message: 'Graph name cannot be used as vertex name or edge name.'
        };
      }
      if (!names.has(name)) {
        names.set(name, 1);
      } else {
        names.set(name, names.get(name) + 1);
      }
      if (names.get(name) > 1) {
        return {
          success: false,
          message: "Vertex or edge name \"".concat(name, "\" cannot be duplicated in one graph.")
        };
      }
      return {
        success: true
      };
    }
  }]);
}();

exports.Graph = Graph;
